import React from "react";
import ReactGA from "react-ga";
import styles from "./themes.module.scss";
import { useIsMobile } from "../../hooks/mobile.js";

const THEME_ICON_SIZE = 90;

ReactGA.initialize("UA-11963560-5");

export default function Themes(props) {
    const isMobile = useIsMobile();
    const { themes } = props;

    const handleScrollToExplore = () => {
        const element = document.querySelector("#science-knowledge-needs-explore");
        window.scrollTo({ top: element.offsetTop - 30, behaviour: "smooth" });

        ReactGA.event({
            category: "SCIKNOW: themes",
            action: "scrollToExplore",
        });
    };

    return (
        <div className={styles.themes}>
            <h2>Overarching Themes</h2>
            <div className={styles.themeList}>
                {themes.map(t => {
                    return (
                        <button
                            className={styles.themeItem}
                            key={t.slug}
                            data-theme={t.theme}
                            onClick={handleScrollToExplore}
                        >
                            <span className={styles.themeItemIcon}>
                                <img
                                    src={"data:image/svg+xml," + encodeURIComponent(t.icon)}
                                    alt={t.theme}
                                    className={styles.themeIconImage}
                                    style={{
                                        height: isMobile ? THEME_ICON_SIZE * 0.5 : THEME_ICON_SIZE,
                                        width: "auto",
                                    }}
                                    width="auto"
                                    height={isMobile ? THEME_ICON_SIZE * 0.5 : THEME_ICON_SIZE}
                                    aria-hidden="true"
                                />
                            </span>
                            <span className={styles.themeItemName}>{t.theme}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
